import clsx from "clsx";
import { NoiseTexture } from "./NoiseTexture";

const radialTop =
  "bg-[radial-gradient(ellipse_60%_50%_at_50%_-5%,_rgba(120,119,198,0.12),_transparent)]";
const radialSide =
  "bg-[radial-gradient(ellipse_40%_40%_at_80%_50%,_rgba(78,78,176,0.06),_transparent)]";

type HeroBackdropProps = {
  /** `absolute` fills the positioned parent (landing hero section). `fixed` pins to the viewport (dashboard / long pages). */
  position?: "absolute" | "fixed";
  className?: string;
};

/**
 * Noise + violet radial glows matching the new landing hero (`NewHeroSection`).
 */
export function HeroBackdrop({
  position = "absolute",
  className,
}: HeroBackdropProps) {
  return (
    <div
      className={clsx(
        "pointer-events-none inset-0 z-0 overflow-hidden",
        position === "fixed" ? "fixed" : "absolute",
        className,
      )}
      aria-hidden
    >
      <NoiseTexture />
      <div className={clsx("absolute inset-0", radialTop)} />
      <div className={clsx("absolute inset-0", radialSide)} />
    </div>
  );
}
